import React from 'react';
import { useAdminStore } from '../../stores/useAdminStore';
import { useAdminVisible } from '../../hooks/useAdminVisible';
import './AddPhotoButton.css';

interface AddPhotoButtonProps {
  eventName: string;
}

export const AddPhotoButton: React.FC<AddPhotoButtonProps> = ({ eventName }) => {
  const openUploadModal = useAdminStore(s => s.openUploadModal);
  const isVisible = useAdminVisible();

  if (!isVisible) {
    return null;
  }

  return (
    <button
      className="add-photo-button event-photo-panel hover-zoom"
      onClick={() => openUploadModal(eventName)}
      title={`Add photos to ${eventName}`}
      data-testid="add-photo-button"
    >
      <div className="add-photo-content">
        <span className="add-photo-button__icon">+</span>
        <span className="add-photo-button__label">Add Photo</span>
      </div>
    </button>
  );
};
